import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

interface CandidateRef {
  uuid: string;
}

export function useAddCandidateTag() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, name }: { candidate: CandidateRef; name: string }) => {
      return axios.post(`/candidate/${candidate.uuid}/tag`, { name });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}

export function useRemoveCandidateTag() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, tagId }: { candidate: CandidateRef; tagId: number }) => {
      return axios.delete(`/candidate/${candidate.uuid}/tag`, {
        data: { tag_id: tagId },
      });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}
